import { createStore, combineReducers, applyMiddleware } from 'redux'

import { persistStore, persistReducer, createMigrate } from 'redux-persist'
import migrations from './Migrations'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'

import authentication from './Reducers/Authentication'
import products from './Reducers/Products'
import user from './Reducers/User'
import shared from './Reducers/Shared'

const persistConfig = {
  key: 'root',
  storage,
  version: 0,
  stateReconciler: autoMergeLevel2,
  migrate: createMigrate(migrations, { debug: false }),
}

const reducers = persistReducer(
  persistConfig,
  combineReducers({ authentication, products, user, shared }),
)

const middlewares = [thunk]
let store
let persistor

store = createStore(reducers, undefined, applyMiddleware(...middlewares))
persistor = persistStore(store)

export { store, persistor }
